'use strict';

function mainProductCarousel() {
    var $carousel = $('.product-hero-carousel');
    $carousel.slick(
        {
            dots: true,
            slidesToShow:1,
            arrows: true
        }
    );
    $('.slick-dots li button').addClass('pdp-carousel-dots');

    const $carouselNav = $('.carousel-nav');
    var navs = ['floor-plans', 'youtube-videos', 'virtual-tour', '360-view'];
    navs.forEach(navSelector => {
        $carouselNav.find(`.nav-${navSelector}`).on('click', (e) => {
            e.preventDefault();
            const index = $carousel.find(`.${navSelector}`).closest('.slick-slide').not('.slick-cloned').index();
            $carousel.slick('slickGoTo', index - 1)
        });
    })

}

function promotionCarousel() {
    $('.promotion-card-container').slick({
        autoplay: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: false,
                    nextArrow: false,
                    infinite: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    prevArrow: false,
                    nextArrow: false
                }
            }
        ]
    });
}

function expandGallery() {
    if ($('#expandGalleryModal').length !== 0) {
        $('#expandGalleryModal').remove();
    }
    var htmlString = '<!-- Modal -->' +
    '<div class="modal fade" id="expandGalleryModal" role="dialog">' +
    '<span class="enter-message sr-only" ></span>' +
    '<div class="modal-dialog expand-Gallery-dialog container">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    '    <h3></h3>' +
    '    <button type="button" class="close pull-right quickmodal-close-button" data-dismiss="modal">' +
    '    </button>' +
    '</div>' +
    '<div class="modal-body"></div>' +
    '</div>' +
    '</div>' +
    '</div>';
    $('body').append(htmlString);
}

function filterImages() {
    $('body').on('click', '.view-links-block li', function () {
        var classSelector = $(this).attr('class');
        $('.view-links-block li').removeClass('active');
        $(this).addClass('active');
        $('.product-hero-carousel').slick('slickUnfilter');

        if (classSelector === 'main-images') {
            $('.product-hero-carousel').slick('slickFilter', '.main-images');
        } else if (classSelector === 'floor-plans') {
            $('.product-hero-carousel').slick('slickFilter', '.floor-plans');
        } else if (classSelector === 'virtual-tour') {
            $('.product-hero-carousel').slick('slickFilter', '.virtual-tour');
        } else if (classSelector === 'youtube-videos') {
            $('.product-hero-carousel').slick('slickFilter', '.youtube-videos');
        } else if (classSelector === 'all-images') {
            $('.product-hero-carousel').slick('slickUnfilter');
        }
    });
}

function getModalHtmlElement() {
    if ($('#interestInProduct').length !== 0) {
        $('#interestInProduct').remove();
    }
    var htmlString = '<!-- Modal -->' +
    '<div class="modal fade" id="interestInProduct" role="dialog">' +
    '<div class="modal-dialog interest-in-product-dialog">' +
    '<div class="modal-content">' +
    '    <button type="button" class="close pull-right" data-dismiss="modal">' +
	'        <span aria-hidden="true">&times;</span>' +
    '    </button>' +
    '<div class="modal-body">' +
    '<h3 class="heading">Lets get you on the road!</h3>' +
	'<div class="sub-title">Interested in this <span>' + $('.product-detail-block .product-name').text() + '?</span> Give us a call at <a href="tel:' + $('.product-detail-block .dealerPhone').val() + '">' + $('.product-detail-block .dealerPhone').val() + '</a> or fill out the form below and well get back to you.</div><div class="custom-form"></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>';
    $('body').append(htmlString);
}

function getLocation() {
    var storeid = $('.product-attribute-block .location').data('locationid');
    var locationMapping = $('.location-mapping').val();
    locationMapping = locationMapping && JSON.parse(locationMapping);
    var location = storeid ? locationMapping[storeid] : null;
    return location;
}

function resetPageTitle() {
    setTimeout(function () {
        if ($('head title').length === 0) {
            $('head').append('<title></title>');
        }
        $('head title').text($('.custom-page-title').val());
    }, 2500);
}

function showInterestedForm() {
    $('#interestInProduct').modal('show');
    return new Promise((resolve) => {
            $('#interestInProduct').find('.custom-form').load($('.iAmIntrestedFormUrl').val(), () => {
            resetPageTitle();
            resolve();
        });
    });
}

module.exports = {
    pdpProudctCarousel: function () {
        mainProductCarousel();
    },

    pdpPromotionCarousel: function () {
        promotionCarousel();
    },

    dialgBox: function () {
        $('body').on('click', '.interested-for-product', showInterestedForm);
        $('body').on('click', '.get-quote-product', async () => {
            await showInterestedForm();
            $('#interestInProduct').on('focus', '#Lead\\.Description', () => $('#interestInProduct').find('#Lead\\.Description').val('Get a Quote'));
        });

        $('#interestInProduct').on('hidden.bs.modal', function () {
            location.reload();
        });
    },

    paymentCalculation: function () {
        $('.customize-payment-form').on('submit', function (e) {
            e.preventDefault();
            var amount = $('.sale-price-text.sale-price').length > 0 ? $('.sale-price-text.sale-price').data('sales-price-value') : $('.fraserway-price').data('fraserway-price-value');
            var formData = $(this).serialize();
            formData = formData + '&amount=' + amount;
            var downPayment=parseFloat($('.down-payment').val());
            amount=parseFloat(amount);
            var biweeklyPayment = $('.customize-payment-form').find('.calculation-result').children()[1];


            if(amount<downPayment)
            {
                $('.customize-payment-form').find('.down-payment').addClass('is-invalid');
                var downpayment = $('#form-contact-email-error').data("downpayment");
                $('.customize-payment-form').find('.down-payment').siblings('.invalid-feedback').text(downpayment);
                $('#form-contact-error').css("display", "block");
                biweeklyPayment.setAttribute("hidden", "hidden");
                return false;
            }
            else{
                biweeklyPayment.removeAttribute("hidden");
                $('#form-contact-error').css("display", "none");
            }
            $.spinner().start();
            $.ajax({
                url: $(this).attr('action'),
                data: formData,
                method: 'POST',
                success: function (response) {
                    $('.bi-weekly-payment').text(response.formatted);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    onClickReintilizeSlick: function () {
        $('body').on('click', '.expand-gallery', function () {
            if (screen.width < 1024) {
                $('.product-carousel').slick('slickUnfilter');
                $('.product-carousel').slick('unslick');
                expandGallery();
                var body = $('.product-carousel').html();
                var title = $('.product-name').html();
                $('#expandGalleryModal .modal-header h3').empty().append(title);
                $('#expandGalleryModal .modal-body').empty().html(body);
                $('#expandGalleryModal').modal('show');
                return;
            }
            let index = $('.product-carousel-wrapper.slick-current').data('slick-index');
            $('.product-carousel').slick('slickUnfilter');

            $('.product-carousel').slick('unslick');
            $('.product-carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '200px',
                dots: true,
                arrows: true
            });
            $('.product-carousel').slick('slickGoTo', index);
            $('.expand-Collapse-gallery-box .collapse-gallery').removeClass('d-none');
            $('.expand-Collapse-gallery-box .expand-gallery').addClass('d-none');
            if (!$('.primary-images').hasClass('image-size')) {
                $('.primary-images').addClass('image-size');
            }
        });
        $('body').on('click', '.quickmodal-close-button', function () {
            mainProductCarousel();
            $('.all-images').trigger('click');
        });

        $('body').on('click', '.collapse-gallery', function () {
            let index = $('.product-carousel-wrapper.slick-current').data('slick-index');
            $('.product-carousel').slick('slickUnfilter');
            $('.product-carousel').slick('unslick');
            mainProductCarousel();
            let index1 = $('.product-carousel-wrapper').length;
            if(index1 > 2){
            	$('.product-carousel').slick('slickGoTo', index);
            }
            $('.expand-Collapse-gallery-box .collapse-gallery').addClass('d-none');
            $('.expand-Collapse-gallery-box .expand-gallery').removeClass('d-none');
            $('.all-images').trigger('click');
            if ($('.primary-images').hasClass('image-size')) {
                $('.primary-images').removeClass('image-size');
            }
        });
    },
    customPdp: function () {
        $('body').on('click', '.js-trigger-trade', function () {
            $('#valueMyTrade').find('.valuemytrade-custom-form').load($('.valueMyTradeUrl').val(), resetPageTitle);
            $('#valueMyTrade').modal('show');
        });

        $('body').on('click', '.finance-block', function () {
            $('#ApplyforFinancing').find('.ApplyforFinancing-custom-form').load($('.ApplyforFinancingUrl').val(), resetPageTitle);
            $('#ApplyforFinancing').modal('show');
        });

        $('#valueMyTrade,#ApplyforFinancing').on('hidden.bs.modal', function () {
            location.reload();
        });

        $('body').on('click', '.ff-ui-dialog button', function () {
            location.reload();
        });

        $('body').on('focusout', 'input[name*="FirstName"]', function () {
            var location = getLocation();
            $('input[name*="Stock_Number__c"]').val($('.Stock_Number').val());
            $('input[name*="Current_Page_URL__c"]').val($('.Current_Page_URL').val());
            if (location) {
                $('select[name*="Location__c"]').val(location).trigger('change');
                // $('select[name*="Location__c"]').find('option[value="' + location + '"]').attr('selected', 'selected');
            }
        });

        $('body').on('click', '.cust-link', function () {
            $('.product-detail-block').addClass('d-none');
            $('.custom-payment-block').removeClass('d-none');
        });

        $('body').on('click', '.close-calculator', function () {
            $('.product-detail-block').removeClass('d-none');
            $('.custom-payment-block').addClass('d-none');
        });

        filterImages();

        $('body').on('click', '.share-text', function () {
            $(this).addClass('disabled');
            var $temp = $('<input>');
            var $url = $(location).attr('href');
            $('body').append($temp);
            $temp.val($url).select();
            document.execCommand('copy');
            $temp.remove();

            var success = 'Share link copied to clipboard';
            status = 'alert-success';
            $('body').append('<div class="email-signup-message"></div>');
            $('.email-signup-message')
            .append('<div class="email-signup-alert text-center ' + status + '">' + success + '</div>');

            setTimeout(function () {
                $('.email-signup-message').remove();
                $('.share-text').removeClass('disabled');
                button.removeAttr('disabled');
            }, 3000);
        });

        $('body').on('click', '.biweekly-info-icon', function () {
            $('.biweekly-payment-info-block').addClass('active');
        });
        $('body').on('click', '.close-info-icon', function () {
            $('.biweekly-payment-info-block').removeClass('active');
        });

        $('body').click(function (e) {
            if (!$(e.target).closest('.biweekly-info-icon').length) {
                $('.biweekly-payment-info-block').removeClass('active');
            }
        });

        var sticky;
        if ($('#onepage-menus').length) {
            if ($(window).width() > 1024) {
                sticky = $('#onepage-menus').offset().top - $('nav').height();
            } else {
                sticky = $('#onepage-menus').offset().top - 131;
            }
        }
		// if($(window).width() > 1024){
        $('#onepage-menus ul li a').onePgaeNav({
            wrapper: '#onepage-menus ul'
        });
        var tabMenuHeight = $('.onepage-menu-block').outerHeight();
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if ($(window).width() < 1024) {
                if ($('.drop-down-tab-links ul li a.active').length) {
                    $('.activetab-link').empty().append($('.drop-down-tab-links ul li a.active').html());
                }
            }
            if (scroll >= sticky) {
                $('.onepage-menu-block').addClass('fixed');
                $('#highlights').css('margin-top', tabMenuHeight);
            } else if ($(window).width() > 1024) {
                if (scroll <= sticky - 100) {
                    $('.onepage-menu-block').removeClass('fixed');
                    $('#highlights').css('margin-top', '0');
                }
            } else if (scroll <= sticky - 20) {
                $('.onepage-menu-block').removeClass('fixed');
                $('#highlights').css('margin-top', '0');
            }
        });        


        $('body').on('click', '.custom-active-text', function () {
            if ($(this).hasClass('current')) {
                $('.custom-active-text').removeClass('current');
                $('.custom-dropdown-lists').removeClass('active');
            } else {
                $('.custom-active-text').removeClass('current');
                $('.custom-dropdown-lists').removeClass('active');
                $(this).addClass('current');
                $(this).next('.custom-dropdown-lists').addClass('active');
            }
        });
        $('body').on('click', '.custom-dropdown-lists li', function () {
            $(this).parents('.custom-dropdown-block').find('.custom-active-text').empty()
                .append($(this).html());
            var currentValue = $(this).data('value');
            $(this).parents('.custom-dropdown-block').find('.custom-active-text').data('value', currentValue);
            $(this).parents('.custom-dropdown-block').find('input').val(currentValue);
            $('.custom-active-text').removeClass('current');
            $('.custom-dropdown-lists').removeClass('active');
        });
        $('body').click(function (e) {
            if (!$(e.target).closest('.custom-active-text').length) {
                $('.custom-active-text').removeClass('current');
                $('.custom-dropdown-lists').removeClass('active');
            }
        });


        $('body').on('click', '.bonus-package-block', function () {
            if ($(this).hasClass('current')) {
                $('.bonus-package-block').removeClass('current');
            } else {
                $(this).addClass('current');
            }
        });
        $('body').click(function (e) {
            if (!$(e.target).closest('.bonus-package-block').length) {
                $('.bonus-package-block').removeClass('current');
            }
        });

        var globalcss;
        var detailcss;

        function renderMe(data) {
            var mywindow = window.open('', 'invoice-box', 'height=1000,width=1000');
            mywindow.document.write('<html><head><title>invoice-box</title>');
            mywindow.document.write('<link rel="stylesheet" href="' + globalcss + '" type="text/css" />');
            mywindow.document.write('<link rel="stylesheet" href="' + detailcss + '" type="text/css" />');

            mywindow.document.write('</head><body >');
            mywindow.document.write(data);
            mywindow.document.write('</body></html>');


            setTimeout(function () {
                mywindow.print();
                mywindow.close();
            }, 1000);
            return true;
        }

        $('body').on('click', '.print-text', function () {
            globalcss = location.origin + $(this).attr('data-globalcss');
            detailcss = location.origin + $(this).attr('data-detailcss');
            renderMe($('<div/>').append($('#print-block').clone()).html());
        });
    },

    AddReadMore: function () {
        var carLmt = 280;
        var readMoreTxt = ' Read More';
        var readLessTxt = ' Read Less';
        var allstr;

        $('.addReadMore').each(function () {
            if ($(this).find('.firstSec').length) { return; }

            allstr = $(this).html();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var dots = "...";
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = "<div class='description-data'>" +firstSet+"<small class='showdots'>"+dots+"</small><div class='SecSec'>"+secdHalf+"</div></div> <div class='readMore-block'><div class='readMore'  title='Click to Show More'>" + readMoreTxt + "</div><div class='readLess' title='Click to Show Less'>" + readLessTxt + '</div></div>';
                $(this).html(strtoadd);
            }
        });

        $(document).on('click', '.readLess', function () {
            $(this).remove();
            $('.addReadMore').each(function () {
                if ($(this).find('.firstSec').length) { return; }

                allstr = $(this).html();
                $(this).html('');
                if (allstr.length > carLmt) {
                    var firstSet = allstr.substring(0, carLmt);
                    var dots = "...";
                    var secdHalf = allstr.substring(carLmt, allstr.length);
                    var strtoadd = "<div class='description-data'>" +firstSet+"<small class='showdots'>"+dots+"</small><div class='SecSec'>"+secdHalf+"</div></div> <div class='readMore-block'><div class='readMore'  title='Click to Show More'>" + readMoreTxt + "</div><div class='readLess' title='Click to Show Less'>" + readLessTxt + '</div></div>';
                    $(this).html(strtoadd);
                }
            });

            $('.description-text').addClass('showlesscontent');
            $('.description-text').removeClass('showmorecontent');
            $('.showdots').removeClass('removedots');
        });

        $(document).on('click', '.readMore', function () {
            $(this).closest('.addReadMore').addClass('showmorecontent');
            $(this).closest('.addReadMore').removeClass('showlesscontent');
            $('.showdots').addClass('removedots');
            allstr = allstr + "<div class='readLess' title='Click to Show Less'>"+ readLessTxt + "</div>"
            $(this).closest('.addReadMore').html('').append().html(allstr);
        });
    }
};

$(document).ready(function () {
    $('a.nav-link').on('click', function (e) {
        e.preventDefault();

        // Remove activeTab class from all links
        $('a.nav-link').removeClass('activeTab');

        // Add activeTab class to the clicked link
        $(this).addClass('activeTab');

        var target = this.hash;
        var $target = $(target);

        // Determine scroll position based on screen width
        var scrollPosition;
        if ($(window).width() > 768) {
            // For screens wider than 768 pixels
            scrollPosition = $target.offset().top - 50;
        } else {
            // For screens 768 pixels and narrower
            scrollPosition = $target.offset().top - 130;
        }

        $('html, body').stop().animate({
            'scrollTop': scrollPosition
        }, 900, 'swing');
    });
});